import { createContext, useContext, useEffect } from 'react'
import type { ModuleKey } from '../routes'

/** The workspace open on the current page, surfaced into the top app header
 *  ("AllCode | Assessments — {company} · [Module]" plus the chat shortcut when
 *  the AI module is open). The Layout provides the setter; the status banners
 *  and hub pages publish. Default is a no-op so components render fine
 *  without the provider (tests). */
export interface OpenWorkspace {
  companySlug: string
  companyName: string
  /** null = company-level page (hub / profile / research). */
  module: ModuleKey | null
}

export const WorkspaceContext = createContext<(w: OpenWorkspace | null) => void>(() => {})

/** Publish the open workspace to the app header for this component's lifetime. */
export function usePublishWorkspace(
  companySlug: string | null,
  companyName: string | null,
  module: ModuleKey | null,
): void {
  const publish = useContext(WorkspaceContext)
  useEffect(() => {
    publish(companySlug && companyName ? { companySlug, companyName, module } : null)
    return () => publish(null)
  }, [publish, companySlug, companyName, module])
}
